export default {
	TABLE_TITLE: 'Grade Scales',
	GRADE_SCALE_ADDED: 'Grade Scale added',
	GRADE_SCALE_EDITED: 'Grade Scale edited',
	GRADE_SCALE_DELETED: 'Grade Scale deleted',
};
